<template>
  <div class="select-wrapper">
    <template v-if="disableSelectIcon">
      <div class="select">{{ currentOptionName }}</div>
    </template>
    <template v-else>
      <select class="select" v-model="currentOptionValue">
        <option v-for="item in optionList" :value="item.value" :key="item.value">{{ item.name }}</option>
      </select>
      <i class="gg-chevron-down select-icon"></i>
    </template>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: [String, Number, Boolean],
      default: null,
    },
    disableSelectIcon: {
      type: Boolean,
      default: false,
    },
    optionList: {
      type: Array,
      required: false,
    },
  },
  emits: ['input'],
  computed: {
    currentOptionName() {
      let optionList = this.optionList || []
      let index = optionList.findIndex(x => x.value === this.value)
      if (index < 0 && optionList.length > 0) {
        index = 0
      }
      if (index < 0) {
        return ''
      }
      return optionList[index].name
    },
    currentOptionValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>

<style lang="less" scoped>
@import '~@/styles/common';

@ggIconScale: 0.75;

.gg-chevron-down {
  box-sizing: border-box;
  position: relative;
  display: block;
  transform: scale(@ggIconScale);
  width: 22px;
  height: 22px;
  border: 2px solid transparent;
  border-radius: 100px;
}

.gg-chevron-down::after {
  content: '';
  display: block;
  box-sizing: border-box;
  position: absolute;
  width: 10px;
  height: 10px;
  border-bottom: 2px solid;
  border-right: 2px solid;
  transform: rotate(45deg);
  left: 4px;
  top: 2px;
}

.select-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

select {
  border: none;
  outline: none;
  appearance: none;
  box-shadow: none;
  margin: 0;
  background-color: transparent;
  background: transparent;

  &::-ms-expand {
    display: none;
  }
}

.select {
  padding: 0 16px 0 16px;
  white-space: nowrap;
  z-index: 2;
  font-weight: bold;
  cursor: default;
}

.disable-select-icon {
  .select {
    padding-left: 0;
  }
}

.select-icon {
  position: absolute;
  left: -6px;
  z-index: 1;
}
</style>
